var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[(_vm.user.user == null)?_c('NotLoggedIn',{staticClass:"top_not_logged_in"}):_vm._e(),(_vm.user.user != null)?_c('LoggedIn',{staticClass:"top_logged_in"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }